
const contentview = [{"key":"contentview.title","string":"Príspevok, ktorý ste pridali do Informačných zdrojov"},{"key":"contentview.add_content_button","string":"Pridať príspevok"},{"key":"contentview.no_content_added","string":"Do Informačných zdrojov ste ešte nepridali žiaden príspevok."},{"key":"contentview.table.title","string":"Nadpis"},{"key":"contentview.table.author","string":"Autor"},{"key":"contentview.table.year","string":"Rok"},{"key":"contentview.full_text","string":"Prejsť do vlastného materiálu"}]

export default contentview



// WEBPACK FOOTER //
// ./src/i18n/sk/addcontent/contentview.js